import { create } from 'zustand';

export interface Notification {
  id: string;
  type: 'success' | 'error' | 'info' | 'warning';
  title: string;
  message?: string;
  duration?: number; // milliseconds, 0 for persistent
  read?: boolean; // Whether the notification has been read
  timestamp: number; // When the notification was created
  action?: { label: string; navigateTo: string; jobId?: string };
}

interface NotificationState {
  notifications: Notification[];
  addNotification: (notification: Omit<Notification, 'id' | 'timestamp'>) => void;
  removeNotification: (id: string) => void;
  markAsRead: (id: string) => void;
  markAllAsRead: () => void;
  clearRead: () => void;
  clearAll: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],

  addNotification: (notification) => {
    const id = `notification-${Date.now()}-${Math.random()}`;
    const newNotification: Notification = {
      id,
      duration: 15000, // Default 15 seconds
      read: false,
      timestamp: Date.now(),
      ...notification,
    };

    set((state) => ({
      notifications: [newNotification, ...state.notifications],
    }));

  },

  removeNotification: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),

  markAsRead: (id) =>
    set((state) => ({
      notifications: state.notifications.map((n) =>
        n.id === id ? { ...n, read: true } : n
      ),
    })),

  markAllAsRead: () =>
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, read: true })),
    })),

  clearRead: () =>
    set((state) => ({
      notifications: state.notifications.filter((n) => !n.read),
    })),

  clearAll: () => set({ notifications: [] }),
}));
